/// <reference path="../../TypeLite.Net4.d.ts" />
import { push } from 'connected-react-router';
import { LocationState, Path } from 'history';
import { isEqual } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppConfig } from '../../appConfig';
import { SkodaNoConnect } from '../../components/skodaNoConnect/skodaNoConnect';
import { TabType } from '../../components/wizard/wizardTabs/WizardTabPane';
import { ResourceProvider } from '../../resourceProvider';
import { ApplicationState, ConnectedReduxProps } from '../../store';
import { fetchRequestGroupeServiceItems, fetchRequestVinCheckResult } from '../../store/overviewPage/actions';
import { showWizardPage } from '../../store/wizardPage/actions';
import { TrackingProvider } from '../../tracking/trackingProvider';
import { Disclaimer } from "./../../components/disclaimer";
import { ServiceItem } from './../../components/serviceItem';
import { SkodaConnectLite } from "./../../components/skodaConnectLite";

interface PropsFromState {
    loading: boolean
    data: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceGroupModel[],
    dataFilter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter,
    importerSettings: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.ImporterSettingsModel,
    errors?: string,
    isCountryManuallySubmitted: boolean,
    readonly trackingProvider: TrackingProvider,
    selectedCountry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel;
    selectedModel: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel;
    selectedInfotaiment: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel;
    selectedProductionInterval: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel;
}

interface PropsFromDispatch {
    fetchRequest: typeof fetchRequestGroupeServiceItems,
    fetchRequestVinCheckResult: typeof fetchRequestVinCheckResult,
    push: typeof push,
    readonly showWizardPage: typeof showWizardPage
}

type IOverviewPageProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps

interface IOverviewPageState {
}

class OverviewPage extends React.Component<IOverviewPageProps, IOverviewPageState> {
    constructor(props: IOverviewPageProps) {
        super(props);

        this.goToDetail = this.goToDetail.bind(this);
        this.onSkodaConnectLightClick = this.onSkodaConnectLightClick.bind(this);
    }

    public shouldComponentUpdate(nextProps: IOverviewPageProps, nextState: IOverviewPageState): boolean {
        var result = isEqual(nextProps, this.props);

        if (!result)
            return true;
        return false;
    }

    public componentDidMount() {
        this.fetchServices();
    }

    public componentDidUpdate(prevProps: IOverviewPageProps) {
        if (!isEqual(prevProps.dataFilter, this.props.dataFilter)) {
            this.fetchServices(this.props.dataFilter.CountryCode !== prevProps.dataFilter.CountryCode);
        }

        if (this.props.dataFilter.CountryCode && !prevProps.dataFilter.CountryCode && !this.props.isCountryManuallySubmitted) {
            const vin = (new URLSearchParams(window.location.search)).get("vin");
            if (vin) {
                this.props.showWizardPage(TabType.Vin, false, true);
            }
        }
    }

    private fetchServices(isCountryCodeChanged?: boolean): void {
        if (!this.props.dataFilter.EnteredVin) {
            this.props.fetchRequest(this.props.dataFilter);
        }
        else if(isCountryCodeChanged === true) {
            this.props.fetchRequestVinCheckResult(this.props.dataFilter);
        }
    }

    private canShowAvailability(): boolean {
        let f = this.props.dataFilter;
        return f != null && (f.CountryCode != null || f.FamilyCode != null || f.InfotainmentCode != null || f.ProductionFromCode != null)
    }

    private canShowSkodaConnectLite(): boolean {
        if (AppConfig.GlobalSetting.IsComContext)
            return this.props.importerSettings && this.props.importerSettings.SkodaConnectLiteLink != null;

        if (this.props.importerSettings && this.props.importerSettings.SkodaConnectLiteCountries) {
            let contextCountry = this.props.importerSettings.CountryCode;
            let exists = this.props.importerSettings.SkodaConnectLiteCountries.filter((c) => c.toLowerCase() == contextCountry.toLowerCase());
            if (exists && exists.length > 0)
                return true;
        }

        return false;
    }

    private canShowSkodaNoConnect(): boolean {
        if (this.props.errors || (this.props.dataFilter.EnteredVin && !this.props.data)) {
            return true;
        }

        return false;
    }

    private goToDetail(code: string, originTitle: string): void {
        this.props.trackingProvider.trackButtonClick(originTitle, null, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
        this.props.push("/service/" + code);
    }

    private onSkodaConnectLightClick(): void {
        this.props.trackingProvider.trackCtaClick(ResourceProvider.getText('SkodaConnectLite.Link'), 'Skoda Connect', this.props.importerSettings.SkodaConnectLiteLink, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
    }

    public render() {
        let canShowAvailability = this.canShowAvailability();

        return (
            <div className="container page overview-page">
                <div className="container page-title-container">
                    <h1>{ResourceProvider.getText('OverviewPage.Title')}</h1>
                    <div className="page-title-description">
                        {ResourceProvider.getText('OverviewPage.Description')}
                    </div>
                </div>
                {
                    this.canShowSkodaNoConnect() &&
                    <SkodaNoConnect
                        title={this.props.errors ? ResourceProvider.getText('ErrorTitle.VinResult') : ResourceProvider.getText('NoSkodaConnect.Title')}
                        text={this.props.errors ? ResourceProvider.getText('ErrorMsg.VinResult') : ResourceProvider.getText('NoSkodaConnect.Text')} />
                }
                {
                    !this.canShowSkodaNoConnect() && this.props.data && this.props.data.map((group) => (
                        <div key={group.Id.toString()} className="container service-group-container">
                            <h3>{group.Title}</h3>
                            <div className="row service-items-row">
                                {
                                    group.Services.map((service, index) => <ServiceItem key={service.Id.toString()} service={service} orderInGroup={index + 1} showAvailability={canShowAvailability} appliedFilter={this.props.dataFilter} onClick={this.goToDetail} />)
                                }
                            </div>
                        </div>
                    ))
                }

                {
                    !this.canShowSkodaNoConnect() && this.canShowSkodaConnectLite() &&
                    <SkodaConnectLite key="overview-skoda-connect-lite" Url={this.props.importerSettings.SkodaConnectLiteLink} onClick={this.onSkodaConnectLightClick} />
                }

                <Disclaimer key="overview-disclaimer" />

            </div>
        )
    }
}

const mapStateToProps = ({ mainPage, filter, common }: ApplicationState) => ({
    loading: mainPage.loading,
    errors: mainPage.errors,
    data: mainPage.data,
    dataFilter: filter.dataFilter,
    importerSettings: common.importerSettings,
    isCountryManuallySubmitted: filter.isCountryManuallySubmitted,
    trackingProvider: common.trackingProvider,
    selectedCountry: filter.selectedCountry,
    selectedModel: filter.selectedModel,
    selectedInfotaiment: filter.selectedInfotaiment,
    selectedProductionInterval: filter.selectedProductionInterval
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchRequest: (filter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter) => dispatch(fetchRequestGroupeServiceItems(filter)),
    fetchRequestVinCheckResult: (filter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter) => dispatch(fetchRequestVinCheckResult(filter)),
    push: (path: Path, state?: LocationState) => dispatch(push(path, state)),
    showWizardPage: (wizardTab: TabType, activateFilterOnClose: boolean, vinCheck: boolean) => dispatch(showWizardPage(wizardTab, activateFilterOnClose, vinCheck)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OverviewPage)


